"use client";
import React from "react";
import { Link } from "react-router-dom";
import OnepageMenuItems from "./OnepageMenuItems";
import MobileLogo from "../../../assets/images/logo-name.png";


const MobileMenu2 = ({
  isSidebar,
  handleMobileMenu,
  handleSidebar,
  ...props
}) => {
  const {
    item1 = "Home",
    item2 = "About",
    item3 = "Team",
    item4 = "Gallery",
    // item5 = "",
    item5 = "Events",
    item6 = "Queue App",
  } = props;

  return (
    <>
      {/* Mobile Menu */}
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
          <img src={MobileLogo} alt="Logo" />
            {/* <Link to="/" aria-label="Logo">
              <img src={MobileLogo} alt="Logo" />
            </Link> */}
          </div>
          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <OnepageMenuItems
                  menuItem1={item1 ? item1 : "Home"}
                  menuItem2={item2 ? item2 : "About"}
                  menuItem3={item3 ? item3 : "Team"}
                  menuItem4={item4 ? item4 : "Gallery"}
                  menuItem7={item5 ? item5 : "Events"}
                  menuItem8={item6 ? item6 : "Queue App"}
              />
            </ul>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope" />
              <a href="mailto:racketriotclub@gmail.com">racketriotclub@gmail.com</a>
            </li>
            <li>
              <i className="fa fa-phone-alt" />
              <a href="tel:09970985227">09970985227</a>
            </li>
          </ul>
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
            <Link to="https://www.facebook.com/profile.php?id=61568695844672" target='blank'>
                              <i className="icon-facebook"></i>
                            </Link>
                            <Link to="https://www.instagram.com/racketriotclub/" target='blank'>
                              <i className="icon-instagram"></i>
                            </Link>
              {/* <Link to="#" className="fab fa-twitter" aria-label="Twitter" />
              <Link to="#" className="fab fa-facebook-square" aria-label="Facebook" />
              <Link to="#" className="fab fa-pinterest-p" aria-label="Pinterest" />
              <Link to="#" className="fab fa-instagram" aria-label="Instagram" /> */}
            </div>
          </div>
        </div>
      </div>
      <div
        className="nav-overlay"
        style={{ display: isSidebar ? "block" : "none" }}
        onClick={handleSidebar}
      />
    </>
  );
};

export default MobileMenu2;
